<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="p-5 flex flex-col">
    <div class="flex flex-row items-center">
      <div
        class="min-w-8 self-center cursor-pointer"
        @click="handleBack"
      >
        <img :src="require('@/assets/shipo-icon-arrow-left.svg')">
      </div>
      <p class="font-semibold text-3xl">
        {{ this.$route.meta.title }}
      </p>
    </div>
    <div class="p-5 mt-5 flex flex-row items-center bg-white rounded-lg justify-between">
      <div class="w-2/3 grid grid-cols-2 gap-x-2 gap-y-4 font-medium">
        <vs-row vs-w="12">
          <vs-col vs-w="4">
            Fleet ID
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{ 
              dailyActiviyData 
                ? dailyActiviyData.fleet_id 
                  ? dailyActiviyData.fleet_id 
                  : '-' 
                : '-'
            }}
          </vs-col>
        </vs-row>
        <vs-row vs-w="12">
          <vs-col vs-w="4">
            Service Trip
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{
              dailyActiviyData
                ? dailyActiviyData.trip_number
                  ? dailyActiviyData.trip_number
                  : '-'
                : '-'
            }}
          </vs-col>
        </vs-row>
        <vs-row vs-w="12">
          <vs-col vs-w="4">
            Tug Name
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{
              dailyActiviyData 
                ? dailyActiviyData.tug_name 
                  ? dailyActiviyData.tug_name 
                  : '-' 
                : '-'
            }}
          </vs-col>
        </vs-row>
        <vs-row vs-w="12">
          <vs-col vs-w="4">
            Buyer
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{
              dailyActiviyData
                ? dailyActiviyData.buyer
                  ? dailyActiviyData.buyer
                  : '-'
                : '-'
            }}
          </vs-col>
        </vs-row>
        <vs-row vs-w="12">
          <vs-col vs-w="4">
            Barge Name
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{
              dailyActiviyData
                ? dailyActiviyData.barge_name 
                  ? dailyActiviyData.barge_name 
                  : '-' 
                : '-' 
            }}
          </vs-col>
        </vs-row>
        <vs-row 
          vs-w="12" 
          v-if="dailyActiviyData.buyer_2 !== null"
        >
          <vs-col vs-w="4">
            Buyer 2
          </vs-col>
          <vs-col vs-w="1">
            :
          </vs-col>
          <vs-col vs-w="7">
            {{
              dailyActiviyData
                ? dailyActiviyData.buyer_2
                  ? dailyActiviyData.buyer_2
                  : '-'
                : '-'
            }}
          </vs-col>
        </vs-row>
      </div>
      <vs-button
        class="button shadow-secondary font-semibold mr-5"
        color="secondary"
        @click="$router.push({ name: 'DailyActivityReportDetail', params: { blu_id: dailyActiviyData.blu_id } })"
      >
        View Report
      </vs-button>
    </div>
    <div class="p-5 flex flex-col mt-3 bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-6"
        @fetch="fetchCheckpoint"
      >
        <template #start>
          <vs-button
            type="border"
            class="button shadow-secondary font-semibold mr-5"
            color="primary"
            @click="handleExpandAll"
          >
            {{ isExpandAll ? 'Expand All' : 'Hide All' }}
          </vs-button>
          <vs-button
            v-if="isUserCanAccessMenu(permission.name, 'add')"
            class="button shadow-primary font-semibold"
            color="primary"
            @click="onHandleAdd(null)"
          >
            Add Checkpoint
          </vs-button>
        </template>
      </table-top>
      <data-table
        class="mt-6"
        :table-header="header"
        :table-data="datas"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        :loading="isBusy"
        body-height="100vh"
        :expanded-rows-list="expandedRowsList"
        @sort="sort"
      >
        <template #no="{ index }">
          <div class="flex flex-row w-min">
            {{ (currentPage - 1) * pageSize + index + 1 }}
          </div>
        </template>
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <template v-if="row.isEditing">
              <div
                :class="`mx-1 self-center flex items-center justify-center icon-transparent-bg complete ${isProcessing && 'cursor-not-allowed animate-bounce opacity-50'}`"
                @click=" isProcessing ? null : onHandleSubmit(row)"
              >
                <img
                  :src="require('@/assets/shipo-icon-check-circle.svg')"
                  alt="save"
                >
              </div>
              <div
                :class="`mx-1 self-center flex items-center justify-center icon-transparent-bg delete ${isProcessing && 'cursor-not-allowed animate-bounce opacity-50'}`"
                @click="isProcessing ? null : onHandleCancel(row)"
              >
                <img
                  :src="require('@/assets/shipo-icon-close-circle.svg')"
                  alt="cancel"
                >
              </div>
            </template>
            <template v-else>
              <div
                class="self-center flex items-center justify-center cursor-pointer icon-transparent-bg"
                @click="toggleRow(row)"
              >
                <img
                  :src="
                    require(
                      expandedRowsList.includes(row.id)
                        ? '@/assets/shipo-icon-arrow-up.svg' : '@/assets/shipo-icon-arrow-down.svg')"
                >
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'edit')"
                class="self-center flex items-center justify-center icon-transparent-bg"
                @click="onHandleEdit(row)"
              >
                <img :src="require('@/assets/shipo-icon-edit.svg')">
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'delete')"
                class="self-center flex items-center justify-center icon-transparent-bg"
                @click="onHandleDelete(row)"
              >
                <img :src="require('@/assets/shipo-icon-delete.svg')">
              </div>
            </template>
          </div>
        </template>
        <template #current_location_name="{ row }">
          <template v-if="row.isEditing">
            <div class="relative w-56">
              <select-with-search
                v-model="row.editForm.current_location_id"
                placeholder="Select current location"
                class="px-2"
                :options="locationOptions"
                :danger="!!!row.editForm.current_location_id"
                :disabled="isProcessing"
              />
            </div>
          </template>
          <div v-else>
            {{ row.current_location_name || '-' }}
          </div>
        </template>
        <template #next_location_name="{ row }">
          <template v-if="row.isEditing">
            <div class="relative w-56">
              <select-with-search
                v-model="row.editForm.next_location_id"
                placeholder="Select next location"
                class="px-2"
                :options="locationOptions"
                :danger="!!!row.editForm.next_location_id"
                :disabled="isProcessing"
              />
            </div>
          </template>
          <div v-else>
            {{ row.next_location_name || '-' }}
          </div>
        </template>
        <template #current_trip_status="{ row }">
          <template v-if="row.isEditing">
            <div class="relative w-56">
              <select-with-search
                hide-search
                v-model="row.editForm.current_trip_status"
                placeholder="Select current trip status"
                class="px-2"
                :options="tripStatusOptions"
                :danger="!!!row.editForm.current_trip_status"
                :disabled="row.has_activity || isProcessing"
              />
            </div>
          </template>
          <template v-else>
            <div
              :class="badgeTripStatusClass(row.current_trip_status)"
              class="badge-trip-status"
            >
              {{
                row.current_trip_status 
                  ? row.current_trip_status.replaceAll('_', ' ').toLowerCase() 
                  : '-'
              }}
            </div>
          </template>
        </template>
        <template #next_trip_status="{ row }">
          <template v-if="row.isEditing">
            <div class="relative w-56">
              <select-with-search
                hide-search
                v-model="row.editForm.next_trip_status"
                placeholder="Select next trip status"
                class="px-2"
                :options="tripStatusOptions"
                :danger="!!!row.editForm.next_trip_status"
                :disabled="row.has_activity || isProcessing"
              />
            </div>
          </template>
          <template v-else>
            <div
              :class="badgeTripStatusClass(row.next_trip_status)"
              class="badge-trip-status"
            >
              {{
                row.next_trip_status 
                  ? row.next_trip_status.replaceAll('_', ' ').toLowerCase() 
                  : '-'
              }}
            </div>
          </template>
        </template>
        <template #lat="{ row }">
          <div v-if="row.isEditing">
            <vs-input
              :value="row.editForm.lat"
              :disabled="isProcessing"
              placeholder="Enter latitude"
              @input="val => onHandleInput(val, row, 'lat')"
              @blur="() => onLatLongBlur(row, 'lat')"
              :danger="row.editForm.lat === '' || isNaN(row.editForm.lat)"
              :danger-text="'* Must be between -90 and 90'"
            />
          </div>
          <div v-else>
            {{ row.lat || '-' }}
          </div>
        </template>
        <template #long="{ row }">
          <div v-if="row.isEditing">
            <vs-input
              :value="row.editForm.long"
              :disabled="isProcessing"
              placeholder="Enter longitude"
              @input="val => onHandleInput(val, row, 'long')"
              @blur="() => onLatLongBlur(row, 'long')"
              :danger="row.editForm.long === '' || isNaN(row.editForm.long)"
              :danger-text="'* Must be between -180 and 180'"
            />
          </div>
          <div v-else>
            {{ row.long || '-' }}
          </div>
        </template>
        <template #departure_dt="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.departure_dt"
              @change="v => {
                row.editForm.arrived_dt = ''
                totalDuration(row, v, row.editForm.arrived_dt)
              }"
              :class="{ 'is-not-valid': !!!row.editForm.departure_dt }"
              :is-valid="!!row.editForm.departure_dt"
              :max="moment().subtract(1, 'day').toDate()"
              :disabled="isProcessing"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.departure_dt, 'DD MMM YYYY HH:mm') }}
          </div>
        </template>
        <template #arrived_dt="{ row }">
          <div v-if="row.isEditing">
            <date-picker
              class="w-full"
              type="datetime"
              format="DD-MMM-YYYY HH:mm"
              v-model="row.editForm.arrived_dt"
              @change="v => totalDuration(row, row.editForm.departure_dt, v)"
              :class="{ 'is-not-valid': !!!row.editForm.arrived_dt }"
              :is-valid="!!row.editForm.arrived_dt"
              :min="
                moment(row.editForm.departure_dt)
                  .subtract(calculateSubtract(row.editForm.departure_dt), 'day')
                  .toDate()
              "
              :max="moment().subtract(1, 'day').toDate()"
              :disabled="!!!row.editForm.departure_dt || isProcessing"
            />
          </div>
          <div v-else>
            {{ validateAndFormatDate(row.arrived_dt, 'DD MMM YYYY HH:mm') }}
          </div>
        </template>
        <template #duration="{ row }">
          {{ row.duration ? row.duration : totalDuration(row, row.departure_dt, row.arrived_dt) }}
        </template>
        <template #detail="{ parentData, parentIndex }">
          <div>
            <div class="flex gap-5">
              <vs-button
                v-if="isUserCanAccessMenu(permission.name, 'add')"
                class="button shadow-primary font-semibold"
                color="primary"
                @click="onHandleAdd(parentData)"
              >
                Add Activity
              </vs-button>
              <div
                class="flex flex-row"
                :class="'self-center'"
              >
                <vs-input
                  icon-no-border
                  :class="['search border border-secondary rounded-md']"
                  v-model="searchChild[parentIndex]"
                  icon="search"
                  placeholder="Search here..."
                  @keyup.enter="handleSearch(parentData, parentIndex)"
                />
              </div>
              <vs-button
                type="border"
                color="primary"
                class="px-2 w-40 self-center font-semibold"
                @click="resetFilter(parentData, parentIndex)"
              >
                Reset
              </vs-button>
            </div>
            <data-table
              class="mt-6"
              :loading="loadingActivity"
              :table-header="headerDetail"
              :table-data="getActivityDataById(parentData.id)"
              :sort-by="filtersChild[parentIndex].sort_by"
              :sort-dir="filtersChild[parentIndex].sort_dir"
              body-height="80vh"
              @sort="(sortBy, sortDir) => sortChild(sortBy, sortDir, parentData, parentIndex)"
            >
              <template #no="{ index }">
                <div class="flex flex-row w-min">
                  {{ index + 1 }}
                </div>
              </template>

              <template #action="{ row }">
                <div class="flex flex-row gap-x-3">
                  <template v-if="row.isEditing">
                    <div
                      :class="`self-center flex items-center justify-center icon-transparent-bg complete ${isProcessing && 'cursor-not-allowed animate-bounce opacity-50'}`"
                      @click="isProcessing ? null : onHandleChildSubmit(row, parentData)"
                    >
                      <img
                        :src="require('@/assets/shipo-icon-check-circle.svg')"
                        alt="save"
                      >
                    </div>
                    <div
                      :class="`self-center flex items-center justify-center icon-transparent-bg delete ${isProcessing && 'cursor-not-allowed animate-bounce opacity-50'}`"
                      @click="isProcessing ? null : onHandleChildCancel(row, parentData)"
                    >
                      <img
                        :src="require('@/assets/shipo-icon-close-circle.svg')"
                        alt="cancel"
                      >
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-if="isUserCanAccessMenu(permission.name, 'edit')"
                      class="self-center flex items-center justify-center icon-transparent-bg"
                      @click="onHandleChildEdit(row, parentData)"
                    >
                      <img :src="require('@/assets/shipo-icon-edit.svg')">
                    </div>
                    <div
                      v-if="isUserCanAccessMenu(permission.name, 'delete')"
                      class="self-center flex items-center justify-center icon-transparent-bg"
                      @click="onHandleDelete({...row, checkpoint_id: parentData.id}, parentIndex)"
                    >
                      <img :src="require('@/assets/shipo-icon-delete.svg')">
                    </div>
                  </template>
                </div>
              </template>
              <template #activity_name="{ row }">
                <template v-if="row.isEditing">
                  <div class="relative w-56">
                    <select-with-search
                      :disabled="isProcessing"
                      hide-search
                      v-model="row.editForm.activity_id"
                      placeholder="Select activity"
                      class="px-2"
                      @input="() => {
                        row.editForm.status_id = null
                        setStatusOptions(row.editForm.activity_id, row)
                      }"
                      :options="getFilteredActivityByParent(parentData)"
                      :danger="!!!row.editForm.activity_id"
                    />
                  </div>
                </template>
                <div v-else>
                  {{ row.activity_name || '-' }}
                </div>
              </template>
              <template #status_name="{ row }">
                <template v-if="row.isEditing">
                  <div class="relative w-56">
                    <select-with-search
                      hide-search
                      v-model="row.editForm.status_id"
                      placeholder="Select status"
                      class="px-2"
                      :options="keyStatusOptions"
                      @input="(val) => {
                        row.editForm.oee_l2 = keyStatusOptions.find(item=>item.value === val).oeeId
                        row.editForm.oee_l3 = null
                      }"
                      :danger="!!!row.editForm.status_id"
                      :disabled="!!!row.editForm.activity_id || isProcessing"
                    />
                  </div>
                </template>
                <div v-else>
                  {{ row.status_name || '-' }}
                </div>
              </template>
              <template #oee_l2="{ row }">
                <template v-if="row.isEditing">
                  <div class="relative w-56">
                    <select-with-search
                      v-model="row.editForm.oee_l2"
                      placeholder="Select OEE (L2)"
                      class="px-2"
                      :is-grouping="true"
                      :disabled="isProcessing"
                      :options="l2Options"
                      @input="() => {
                        row.editForm.oee_l3 = null
                      }"
                    />
                  </div>
                </template>
                <div v-else>
                  {{ populateL2ValueText(row.oee_l2) }}
                </div>
              </template>
              <template #oee_l3="{ row }">
                <template v-if="row.isEditing">
                  <div class="relative w-56">
                    <select-with-search
                      hide-search
                      v-model="row.editForm.oee_l3"
                      placeholder="Select OEE (L3)"
                      class="px-2"
                      :options="populateL3Options(row.editForm.oee_l2)"
                      :disabled="!!!row.editForm.oee_l2 || !populateL3Options(row.editForm.oee_l2).length || isProcessing"
                    />
                  </div>
                </template>
                <div v-else>
                  {{ populateL3ValueText(row.oee_l3, row.oee_l2) }}
                </div>
              </template>
              <template #activity_start_dt="{ row }">
                <div v-if="row.isEditing">
                  <date-picker
                    class="w-full"
                    type="datetime"
                    format="DD-MMM-YYYY HH:mm"
                    v-model="row.editForm.activity_start_dt"
                    @change="v => {
                      row.editForm.activity_stop_dt = ''
                      totalDuration(row, v, row.editForm.activity_stop_dt)
                    }"
                    :class="{ 'is-not-valid': !!!row.editForm.activity_start_dt }"
                    :is-valid="!!row.editForm.activity_start_dt"
                    :min="moment(parentData.departure_dt).subtract(1, 'day').toDate()"
                    :max="moment(parentData.arrived_dt).subtract(0, 'day').toDate()"
                    :disabled="isProcessing"
                  />
                </div>
                <div v-else>
                  {{ validateAndFormatDate(row.activity_start_dt, 'DD MMM YYYY HH:mm') }}
                </div>
              </template>
              <template #activity_stop_dt="{ row }">
                <div v-if="row.isEditing">
                  <date-picker
                    class="w-full"
                    type="datetime"
                    format="DD-MMM-YYYY HH:mm"
                    v-model="row.editForm.activity_stop_dt"
                    @change="v => totalDuration(row, row.editForm.activity_start_dt, v)"
                    :class="{ 'is-not-valid': !!!row.editForm.activity_stop_dt }"
                    :is-valid="!!row.editForm.activity_stop_dt"
                    :min="
                      moment(row.editForm.activity_start_dt)
                        .subtract(calculateSubtract(row.editForm.activity_start_dt), 'day')
                        .toDate()
                    "
                    :max="moment(parentData.arrived_dt).subtract(0, 'day').toDate()"
                    :disabled="!!!row.editForm.activity_start_dt || isProcessing"
                  />
                </div>
                <div v-else>
                  {{ validateAndFormatDate(row.activity_stop_dt, 'DD MMM YYYY HH:mm') }}
                </div>
              </template>
              <template #duration="{ row }">
                {{ row.duration ? row.duration : totalDuration(row, row.activity_start, row.activity_stop) }}
              </template>
              <template #lat="{ row }">
                <div v-if="row.isEditing">
                  <vs-input
                    :value="row.editForm.lat"
                    placeholder="Enter latitude"
                    @input="val => onHandleInput(val, row, 'lat')"
                    @blur="() => onLatLongBlur(row, 'lat')"
                    :danger="isNaN(row.editForm.lat) && row.editForm.lat"
                    :danger-text="'* Must be between -90 and 90'"
                    :disabled="isProcessing"
                  />
                </div>
                <div v-else>
                  {{ row.lat || '-' }}
                </div>
              </template>
              <template #long="{ row }">
                <div v-if="row.isEditing">
                  <vs-input
                    :value="row.editForm.long"
                    placeholder="Enter longitude"
                    @input="val => onHandleInput(val, row, 'long')"
                    @blur="() => onLatLongBlur(row, 'long')"
                    :danger="isNaN(row.editForm.long) && row.editForm.long"
                    :danger-text="'* Must be between -180 and 180'"
                    :disabled="isProcessing"
                  />
                </div>
                <div v-else>
                  {{ row.long || '-' }}
                </div>
              </template>
              <template #note="{ row }">
                <div v-if="row.isEditing">
                  <vs-input
                    v-model="row.editForm.note"
                    placeholder="Enter notes"
                    :disabled="isProcessing"
                  />
                </div>
                <div v-else>
                  {{ row.note || '-' }}
                </div>
              </template>
            </data-table>
          </div>
        </template>
      </data-table>
      <table-bottom
        class="mt-6"
        @fetch="fetchCheckpoint"
      />
    </div>
    <pop-up
      :active.sync="popUp.isShown"
      is-warning
      :title="`Delete ${popUp.parentIndex > -1 ? 'Activity' : 'Checkpoint'}`"
      left-button="Cancel"
      right-button="Yes, Delete"
      :is-busy="isProcessing"
      @close="popUp = { isShown: false, parentIndex: null, tempId: null, tempName: '' }"
      @leftButton="popUp = { isShown: false, parentIndex: null, tempId: null, tempName: '' }"
      @rightButton="deleteCheckpoint"
    >
      <p class="text-center mt-1">
        Are you sure want to delete {{ popUp.parentIndex > -1 ? 'Activity' : 'Trip Checkpoint Activity' }} "{{ popUp.tempName }}"?
      </p>
      <p class="text-center">
        This action cannot be undone
      </p>
    </pop-up>
    <pop-up
      :active.sync="popUpSuccess"
      @close="resetTableFilter"
      @ok="resetTableFilter"
      title="Success"
    >
      {{ `${popUp.parentIndex > -1 ? 'Activity' : 'Trip Checkpoint Activity'} successfully deleted.` }}
    </pop-up>
  </div>
</template>

<script>
import { groupBy, isEmpty } from 'lodash'
import { mapGetters } from 'vuex'

import api from '@/api/index'
import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import PopUp from '@/components/popUp'
import SelectWithSearch from '@/components/selectWithSearch'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    DataTable,
    DatePicker,
    TableBottom,
    TableTop,
    SelectWithSearch,
    PopUp
  },
  data: () => ({
    isBusy: false,
    isProcessing: false,
    dailyActiviyData: JSON.parse(localStorage.getItem('dailyActivityData')),
    header: [
      { key: 'no', label: 'No', width: '50px' },
      { key: 'action', label: 'Action' },
      { key: 'current_location_name', label: 'Current Location', sortable: true },
      { key: 'next_location_name', label: 'Next Location', sortable: true },
      { key: 'current_trip_status', label: 'Current Trip Status', sortable: true },
      { key: 'next_trip_status', label: 'Next Trip Status', sortable: true },
      { key: 'lat', label: 'Latitude', sortable: true },
      { key: 'long', label: 'Longitude', sortable: true },
      { key: 'departure_dt', label: 'Departure Date', width: '230px', sortable: true },
      { key: 'arrived_dt', label: 'Arrival Date', width: '230px', sortable: true },
      { key: 'duration', label: 'Duration (Hours)' }
    ],
    headerDetail: [
      { key: 'no', label: 'No', width: '50px' },
      { key: 'action', label: 'Action' },
      { key: 'activity_name', label: 'Activity', sortable: true },
      { key: 'status_name', label: 'Status', sortable: true },
      { key: 'oee_l2', label: 'OEE L2', sortable: true },
      { key: 'oee_l3', label: 'OEE L3', sortable: true },
      { key: 'activity_start_dt', label: 'Activity Start', width: '240px', sortable: true },
      { key: 'activity_stop_dt', label: 'Activity Stop', width: '240px', sortable: true },
      { key: 'duration', label: 'Duration (Hours)' },
      { key: 'lat', label: 'Latitude', sortable: true },
      { key: 'long', label: 'Longitude', sortable: true },
      { key: 'note', label: 'Notes', sortable: true }
    ],
    datas: [],
    activityRowData: [],
    loadingActivity: false,
    filters: {
      sort_by: 'departure_dt',
      sort_dir: 'ASC'
    },
    popUp: {
      isShown: false,
      parentIndex: null,
      tempId: null,
      tempParentId: null,
      tempName: ''
    },
    popUpSuccess: false,
    isAdding: false,
    expandedRowsList: [],
    locationOptions: [],
    keyActivityOptions: [],
    keyStatusOptions: [],
    keyDropdownOptions: [],
    l2Options: [],
    l3Options: [],
    searchChild: [],
    filtersChild: [],
    isExpandAll: true
  }),
  computed: {
    ...mapGetters({
      checkpointData: 'ManageActivity/checkpointData',
      tripStatusOptions: 'KeyActivityStatus/tripStatusOptions',
      locations: 'LocationManagement/locations',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      totalData: 'Table/totalData',
      totalPage: 'Table/totalPage',
      search: 'Table/search',
      oeeLvl2Options: 'KeyActivityStatus/oeeLvl2Options'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    oeeLvl2Options: {
      handler(val) {
        const groupedOptions = groupBy(val, (l2)=> l2.parent.name)
        this.l2Options = Object.keys(groupedOptions).map(key => ({
          id: groupedOptions[key][0].parent_id,
          text: key,
          value: key,
          children: groupedOptions[key].map(go => ({id: go.id, text:  (go?.code ? `${go?.code} - ` : '') + go.original_name, value: go.id}))
        }))
      }
    },
    checkpointData: {
      handler(val) {
        if (val) {
          this.expandedRowsList = this.$options.data().expandedRowsList;
          this.activityRowData = this.$options.data().activityRowData;

          this.datas = val
          val.map(_ => {
            this.searchChild.push('')
            this.filtersChild.push({
              sort_by: 'activity_start_dt',
              sort_dir: 'asc'
            })
          })
        }
      }
    },
    locations: {
      handler(val) {
        if (val) {
          const filteredLocation = val.filter(v => v.is_active)
          this.locationOptions = filteredLocation.map(item => ({
            text: item.name,
            value: item.id
          }));
        }
      }
    }
  },
  mounted() {
    this.fetchKeyActivityOptions()
    this.fetchLocationOptions()
    this.fetchKeyActivities()
    this.fetchOeeLv2()
  },
  methods: {
    populateL2ValueText(id) {
      if(id) {
        return this.oeeLvl2Options.find(item => item.id === id).original_name
      }
      return '-'
    },
    populateL3ValueText(id, l2Id) {
      if(id && l2Id) {
        return this.oeeLvl2Options.find(item => item.id === l2Id ).children.find(ch => ch.id === id).name
      }
      return '-'
    },
    populateL3Options(l2Value) {
      if (l2Value) {
        return this.oeeLvl2Options.find(item => item.id === l2Value).children.map(item => ({id: item.id, value: item.id, text: item.name}))
      }
      return []
    },
    async fetchOeeLv2() {
      try {
        await this.$store.dispatch('KeyActivityStatus/getOeeLvl2');
      } catch (error) {
        this.showFailedNotification(this, 'Failed to fetch Key Activity list, please try again')
      }
    },
    isDowntime(statusId) {
      if (statusId) {
        const tempActivity = this.keyActivityOptions?.find(v => v.status?.some(k => k.id === statusId))
        const tempType = tempActivity?.status?.find(v => v.id === statusId)?.type

        return tempType === 'DOWNTIME'
      }
      
      return false
    },
    handleExpandAll() {
      this.datas.map(tr => {
        if (this.isExpandAll) {
          if (!tr.isExpand) {
            tr.isExpand = true
            this.expandedRowsList.push(tr.id); // Expand
            this.fetchActivities(tr.id)
          }
        } else {
          if (tr.isExpand) {
            const index = this.expandedRowsList.indexOf(tr.id);
            tr.isExpand = false
            this.expandedRowsList.splice(index, 1); // Collapse
          }
        }
      })

      this.isExpandAll = !this.isExpandAll
    },
    handleSearch(parentData, parentIndex) {
      this.fetchActivities(parentData.id, parentIndex)
    },
    async fetchKeyActivities() {
      try {
        const apiFilters = {
          is_master_data: true,
          status: true,
          visibility: 'b,o,t,both,blms only'
        };
        const { data } = await api.getKeyActivities(apiFilters);
        if(data && data.length) this.keyActivityOptions = data.filter(act => act.status.length > 0) 
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Key Activity list, please try again')
      }
    },
    getFilteredActivityByParent(parentData) {
      const filteredOptions = this.keyActivityOptions.filter(v => v.trip_status === parentData.current_trip_status)
      return filteredOptions.map(v => ({ value: v.id, text: v.name }))
    },
    setStatusOptions(id) {
      if (id) {
        const tempStatus = this.keyActivityOptions?.find(v => v?.id === id)?.status
        this.keyStatusOptions = tempStatus?.map(v => ({ value: v?.id, text: v?.name, oeeId: v['oee.id'] }))
      } else {
        this.keyStatusOptions = []
      }
    },
    async fetchCheckpoint() {
      try {
        this.isBusy = true
        const payload = {
          id: this.dailyActiviyData.blu_id,
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            sort_dir: this.filters.sort_dir || 'ASC',
            sort_by: this.filters.sort_by || 'departure_dt'
          }
        };

        await this.$store.dispatch('ManageActivity/fetchCheckpoints', payload)

        this.isAdding = false
        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch trip checkpoint list, please try again')
      }
    },
    async fetchActivities(id, parentIndex) {
      this.cancelAllEdits()
      try {
        this.loadingActivity = true
        const payload = {
          id: this.dailyActiviyData.blu_id,
          checkpoint_id: id,
          params: {
            sort_dir: this.filtersChild?.[parentIndex]?.sort_dir || 'asc',
            sort_by: this.filtersChild?.[parentIndex]?.sort_by || 'activity_start_dt',
            search: parentIndex < 0 || this.searchChild[parentIndex] === '' ? null : this.searchChild[parentIndex]
          }
        };
      
        const data = await this.$store.dispatch('ManageActivity/fetchActivities', payload)

        const existData = this.activityRowData.findIndex(v => v.id === id)
        if (existData > -1) {
          this.activityRowData.splice(existData, 1, {
            id: id,
            activity: data 
          })
        } else {
          this.activityRowData.push({
            id: id,
            activity: data
          })
        }

        this.loadingActivity = false
      } catch (error) {
        this.loadingActivity = false
        this.showFailedNotification(this, 'Failed to fetch trip activity list, please try again')
      }
    },
    getActivityDataById(id) {
      const data = this.activityRowData.find(v => v.id === id)

      return !isEmpty(data) ? data.activity.map(va=>{
        const oeeL2 = this.oeeLvl2Options.find(l2=> l2.id === va.oee_id || l2.children.find(ch => ch.id === va.oee_id))
        const oeeL3 = oeeL2 ? oeeL2.children.find(ch => ch.id === va.oee_id) : null
        return {
          ...va,
          oee_l2: oeeL2 ?  oeeL2.id : null,
          oee_l3: oeeL3 ? oeeL3.id : null
        }
      }) : []
    },
    async fetchKeyActivityOptions() {
      await this.$store.dispatch('KeyActivityStatus/getTripStatusOptions');
    },
    async fetchLocationOptions() {
      const params = {
        page: 1,
        limit: 1000
      }
      await this.$store.dispatch('LocationManagement/fetchLocations', params)
    },
    validateAndFormatDate(date, format) {
      // every falsy data transformed into '-'
      if (date && date !== '-') {
        return this.moment(date, ['DD-DD/M', 'YYYY-MM-DDTHH:mm:ss.SSSSZ']).format(format)
      }
      return '-'
    },
    calculateSubtract(date) {
      if (date) {
        const hour = date.getHours()
        const minute = date.getMinutes()
        const second = date.getSeconds()

        if (hour > 0 || minute > 0 || second > 0) {
          return 1
        }

        return 0
      }
    },
    totalDuration(row, start_date, end_date) {
      if (start_date && end_date) {
        const start = new Date(start_date)
        const end = new Date(end_date)

        const durationMs = end - start
        const hours = durationMs / (1000 * 60 * 60)

        row.duration = hours.toFixed(2)
        return hours.toFixed(2)
      }
      row.duration = 0
      return 0
    },
    toggleRow(tr) {
      const index = this.expandedRowsList.indexOf(tr.id);
      if (index > -1) {
        tr.isExpand = false
        this.expandedRowsList.splice(index, 1); // Collapse
      } else {
        tr.isExpand = true
        this.expandedRowsList.push(tr.id); // Expand
        this.fetchActivities(tr.id)
      }
    },
    async handleBack() {
      this.$router.back()
    },
    onHandleAdd(parentData) {
      // Validate if have active action
      if (this.isAdding || this.datas.some(r => r.isEditing) || this.activityRowData.some(v => v?.activity?.some(r => r.isEditing))) {
        this.showFailedNotification(this, 'Only one action can be active at a time. Please save your changes first', 'Error')
        return
      }

      // Create new row
      if (parentData === null) {
        const newRow = {
          id: `new-${Date.now()}`, // Temporary ID for new row
          isEditing: true,
          editForm: {
            current_location_id: '',
            next_location_id: '',
            current_trip_status: '',
            next_trip_status: '',
            lat: '',
            long: '',
            departure_dt: '',
            arrived_dt: '',
            fleetset_id: this.dailyActiviyData.fleet_id,
            blu_internal_id: this.dailyActiviyData.blu_id
          }
        }

        this.datas.unshift(newRow)
      } else {
        const newRow = {
          id: `new-${Date.now()}`, // Temporary ID for new row
          isEditing: true,
          editForm: {
            activity_id: '',
            status_id: '',
            activity_start_dt: '',
            activity_stop_dt: '',
            duration: '',
            lat: '',
            long: '',
            note: ''
          }
        }

        if (this.activityRowData.length) {
          this.activityRowData.find(v => v.id === parentData.id).activity.unshift(newRow)
        } else {
          this.activityRowData.push({
            id: parentData.id,
            activity: [newRow]
          })
        }
      }
      
      this.isAdding = true
    },
    onHandleCancel(row) {
      if (this.isAdding) {
        // Remove the new row if we're canceling an add
        const index = this.datas.findIndex(item => item.id === row.id)
        if (index !== -1) {
          this.datas.splice(index, 1)
        }
      } else {
        // Just cancel the edit
        const index = this.datas.findIndex(item => item.id === row.id)
        if (index !== -1) {
          this.datas[index].isEditing = false
          this.$set(this.datas[index], 'isEditing', false)
        }
      }
      this.isAdding = false
    },
    async resetTableFilter() {
      await this.$store.dispatch('Table/resetConfig')
      this.popUpSuccess = false
    },
    onHandleInput(val, row, type) {
      // Prepend 0 if value starts with '.'
      if (val.startsWith('.')) val = `0${val}`;
      if (val.startsWith('-.')) val = `-0${val.slice(1)}`;

      // Allow empty string temporarily
      if (val === '') {
        row.editForm[type] = '';
        return;
      }

      // Allow partial valid input (not a valid number yet)
      if (
        val === '-' ||
        val === '-0' ||
        val === '-0.' ||
        val === '.' ||
        val === '-.' ||
        /^-?0?\.$/.test(val)
      ) {
        row.editForm[type] = val;
        return;
      }

      // Try to parse to float
      let parsed = parseFloat(val);

      // If not a number, don't update
      if (isNaN(parsed)) return;

      // Clamp value
      if (type === 'lat') {
        if (parsed < -90) parsed = -90;
        if (parsed > 90) parsed = 90;
      } else {
        if (parsed < -180) parsed = -180;
        if (parsed > 180) parsed = 180;
      }

      row.editForm[type] = parsed;
    },
    onLatLongBlur(row, type) {
      const val = row.editForm[type];
      // If the value is exactly '-0', '-0.', or '-0.0', set to 0
      if (val === '-0' || val === '-0.' || val === '-0.0' || val === '-') {
        row.editForm[type] = '0';
      }
      // Optionally, you can also handle cases like '-0.00', etc.
      else if (/^-0\.0*$/.test(val)) {
        row.editForm[type] = '0';
      }
    },
    onHandleChildCancel(row, parentData) {
      if (this.isAdding) {
        // Remove the new row if we're canceling an add
        const pIndex = this.activityRowData.findIndex(item => item.id === parentData.id)
        if (pIndex !== -1) {
          this.activityRowData[pIndex].activity.splice(0, 1)
        }
      } else {
        // Just cancel the edit
        const pIndex = this.activityRowData.findIndex(item => item.id === parentData.id)
        const cIndex = this.activityRowData[pIndex].activity.findIndex(item => item.id === row.id)
        if (cIndex !== -1) {
          this.$set(this.activityRowData[pIndex].activity[cIndex], 'isEditing', false)
        }
      }
      this.isAdding = false
    },
    onHandleDelete(row, parentIndex) {
      if (this.isAdding || this.datas.some(r => r.isEditing) || this.activityRowData?.some(v => v?.activity?.some(r => r.isEditing))) {
        this.showFailedNotification(this, 'Only one action can be active at a time. Please save your changes first', 'Error')
        return
      }

      let populateName;
      if (parentIndex > -1) {
        populateName = row.activity_name
      } else {
        populateName = `${row.current_location_name} - ${row.next_location_name}`
      }
      this.popUp = { isShown: true, parentIndex: parentIndex , tempId: row.id, tempName: populateName, tempParentId: row.checkpoint_id || null }
    },
    async deleteCheckpoint() {
      try {
        this.isProcessing = true
        if (!this.popUp.tempParentId) {
          const payload = {
            id: this.dailyActiviyData.blu_id,
            checkpoint_id: this.popUp.tempId
          }

          await this.$store.dispatch('ManageActivity/deleteCheckpoint', payload)
        } else {
          const payload = {
            id: this.dailyActiviyData.blu_id,
            checkpoint_id: this.popUp.tempParentId,
            activity_id: this.popUp.tempId
          }
          await this.$store.dispatch('ManageActivity/deleteActivity', payload)
        }

        this.showSuccessNotification(this, `${!this.popUp.parentIndex ? 'Checkpoint' : 'Activity'} successfully deleted.`)
        if (!this.popUp.parentIndex) {
          this.fetchCheckpoint()
        } else {
          await this.fetchActivities(this.popUp.tempParentId)
        }
        this.isProcessing = false
        this.popUp = this.$options.data().popUp
      } catch (e) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Request failed (CORS or network issue).')
      }
    },
    onHandleEdit(row) {
      // Cancel any existing edit or add
      if (this.isAdding || this.datas.some(r => r.isEditing) || this.activityRowData.some(v => v.activity.some(r => r.isEditing))) {
        this.showFailedNotification(this, 'Only one action can be active at a time. Please save your changes first', 'Error')
        return
      }

      // Populate Edit Form
      const index = this.datas.findIndex(item => item.id === row.id)
      if (index !== -1) {
        this.$set(this.datas[index], 'isEditing', true)
        this.$set(this.datas[index], 'editForm', {
          id: row.id,
          current_location_id: row.current_location_id,
          next_location_id: row.next_location_id,
          current_trip_status: row.current_trip_status,
          next_trip_status: row.next_trip_status,
          lat: row.lat,
          long: row.long,
          departure_dt: this.moment(row.departure_dt).toDate(),
          arrived_dt: this.moment(row.arrived_dt).toDate(),
          fleetset_id: this.dailyActiviyData.fleet_id,
          blu_internal_id: this.dailyActiviyData.blu_id
        })
      }
    },
    onHandleChildEdit(row, parentData) {
      // Cancel any existing edit or add
      if (this.isAdding || this.datas.some(r => r.isEditing) || this.activityRowData.some(v => v.activity.some(r => r.isEditing))) {
        this.showFailedNotification(this, 'Only one action can be active at a time. Please save your changes first', 'Error')
        return
      }

      // Populate Edit Form
      const pIndex = this.activityRowData.findIndex(item => item.id === parentData.id)
      const cIndex = this.activityRowData[pIndex].activity.findIndex(item => item.id === row.id)

      this.setStatusOptions(row.activity_id)

      if (cIndex !== -1) {
        this.$set(this.activityRowData[pIndex].activity[cIndex], 'isEditing', true)
        this.$set(this.activityRowData[pIndex].activity[cIndex], 'editForm', {
          id: row.id,
          activity_id: row.activity_id,
          status_id: row.status_id,
          activity_start_dt: this.moment(row.activity_start_dt).toDate(),
          activity_stop_dt: this.moment(row.activity_stop_dt).toDate(),
          duration: row.duration,
          lat: row.lat,
          long: row.long,
          note: row.note,
          oee_l2: row.oee_l2,
          oee_l3: row.oee_l3
        })
      }
    },
    async onHandleSubmit(row) {
      // Validate fields
      const { editForm } = row
      const validate = Object.keys(editForm)
        .find(key => key !== 'duration' && key !== 'fleetset_id' && (editForm[key] === '' || editForm[key] === null))

      if (validate) {
        this.showFailedNotification(
          this,
          `Checkpoint ${validate.replaceAll('_', ' ').replace('id', '')} cannot be empty`,
          'Error'
        )
        return
      }

      try {
        this.isProcessing = true
        if (this.isAdding) {
          await this.$store.dispatch('ManageActivity/postCheckpoint', editForm)

          this.showSuccessNotification(this, 'Checkpoint successfully added.')
        } else {
          const { id, ...dataForm } = editForm
          const tempForm = {
            id: this.dailyActiviyData.blu_id,
            checkpoint_id: id,
            form: dataForm
          }
          await this.$store.dispatch('ManageActivity/putCheckpoint', tempForm)

          this.showSuccessNotification(this, 'Checkpoint successfully updated.')
        }

        this.fetchCheckpoint()
        this.isProcessing = false
      } catch ({ error }) {
        this.isProcessing = false
        const message = error?.errors?.[0]?.[0]?.message || error?.errors || error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    async onHandleChildSubmit(row, parentData) {
      // Validate fields
      const { editForm, isEditing } = row
      const notRequired = ['duration', 'note', 'lat', 'long', 'oee_l2', 'oee_l3']
      if (editForm.status_id && this.isDowntime(editForm.status_id)) {
        notRequired.splice(0, 1)
      }
      
      const validate = Object.keys(editForm)
        .find(key => !notRequired.includes(key) && (editForm[key] === '' || editForm[key] === null || editForm[key] === undefined))

      if (validate) {
        this.showFailedNotification(
          this,
          `Trip Checkpoint Activity ${validate.replaceAll('_', ' ').replace('id', '')} cannot be empty`,
          'Error'
        )
        return
      }

      try {
        const { duration, ...tempEditForm } = editForm
        this.isProcessing = true
        if (this.isAdding) {
          if(tempEditForm.oee_l3) {
            tempEditForm.oee_id = tempEditForm.oee_l3
          } else if(tempEditForm.oee_l2) {
            tempEditForm.oee_id = tempEditForm.oee_l2
          }
          if(!tempEditForm.lat) {
            tempEditForm.lat = null
          }
          if(!tempEditForm.long) {
            tempEditForm.long = null
          }
          delete tempEditForm.oee_l2
          delete tempEditForm.oee_l3

          const payload = {
            id: this.dailyActiviyData.blu_id,
            checkpoint_id: parentData.id,
            form: tempEditForm
          }

          // Handle Add Child (Activity)
          await this.$store.dispatch('ManageActivity/postActivity', payload)

          this.showSuccessNotification(this, 'Trip Checkpoint Activity successfully added.')
        } else {
          const { id, ...dataForm } = tempEditForm
          if(dataForm.oee_l3) {
            dataForm.oee_id = dataForm.oee_l3
          } else if(dataForm.oee_l2) {
            dataForm.oee_id = dataForm.oee_l2
          }
          if(!dataForm.lat) {
            dataForm.lat = null
          }
          if(!dataForm.long) {
            dataForm.long = null
          }
          delete dataForm.oee_l2
          delete dataForm.oee_l3

          const payload = {
            id: this.dailyActiviyData.blu_id,
            checkpoint_id: parentData.id,
            activity_id: id,
            form: dataForm
          }

          // Handle Edit Child (Activity)
          await this.$store.dispatch('ManageActivity/putActivity', payload)
        
          this.showSuccessNotification(this, 'Trip Checkpoint Activity successfully updated')
        }

        this.popUp = this.$options.data().popUp;
        this.cancelAllEdits()
        this.fetchActivities(parentData.id)
        this.isProcessing = false
      } catch ({ error }) {
        this.isProcessing = false
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Failed to save changes, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    cancelAllEdits() {
      // Remove Index 1 For isAdding
      if (this.datas.length > this.pageSize) {
        this.datas.splice(0, 1)
      }
      
      // Cancel any existing edit
      this.datas.map(row => {
        if (row.isEditing) {
          this.$set(row, 'isEditing', false)
        }
      })

      this.activityRowData?.map(cRow => {
        cRow?.activity?.map(child => {
          if (child.isEditing) {
            this.$set(child, 'isEditing', false)
          }
        })
      })
      this.isAdding = false
    },
    sort(sortBy, sortDir) {
      this.filters.sort_by = sortBy;
      this.filters.sort_dir = sortDir;
      this.fetchCheckpoint();
    },
    sortChild(sortBy, sortDir, parentData, parentIndex) {
      this.filtersChild[parentIndex].sort_by = sortBy;
      this.filtersChild[parentIndex].sort_dir = sortDir;
      this.fetchActivities(parentData.id, parentIndex);
    },
    resetFilter(parentData, parentIndex) {
      if (!this.isEmpty(this.searchChild[parentIndex])) {
        this.searchChild[parentIndex] = ''
        this.filtersChild[parentIndex] = {
          sort_dir: 'asc',
          sort_by: 'activity_start_dt'
        }
      }
      this.fetchActivities(parentData.id, parentIndex)
    },
    badgeTripStatusClass(status) {
      switch (status) {
        case 'UNLOADING':
          return 'unloading';
        case 'LOADING':
          return 'loading';
        case 'IN_TRANSIT':
          return 'intransit';
        case 'OUT_TRANSIT':
          return 'outtransit';
        default:
          return 'default';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  background-color: #493493;
  border-radius: 0.5rem;

  &.complete {
    background-color: #D1F9E3;
  }

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}

.icon-disable-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  border-radius: 0.5rem;

  background-color: #64646433;
}

.badge-status {
  background-color: #4CAF5033;
  color: #4CAF50;
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;

  &.inactive {
    background-color: #DB111133;
    color: #DB1111;
  }
}

.badge-trip-status {
  text-align: center;
  padding: 5px 0;
  border-radius: 5px;
  text-transform: capitalize;

  &.outtransit {
    background-color: #4CAF5033;
    color: #4CAF50;
  }

  &.intransit {
    background-color: #5382FB33;
    color: #5382FB;
  }

  &.loading {
    background-color: #FBB23333;
    color: #F9BF59;
  }

  &.unloading {
    background-color: #DB111133;
    color: #DB1111;
  }

  &.default {
    background-color: #4CAF5033;
    color: #4CAF50;
  }
}

/deep/.con-select {
  @apply w-auto rounded-lg;
}

/deep/.vs-con-input-label {
  width: 200px !important;
}

/deep/.input-select-con {
  max-width: 3.5rem;
}

/deep/.vs-select--input {
  @apply pr-0 rounded-lg;

  border: 0 none transparent;
}

/deep/.vs-select--icon {
  right: 0.25px;
  @apply text-secondary;
  font-size: 20px;
}

/deep/.vs-input--input {
  @apply bg-white;
  @apply h-12 rounded-lg;
  padding-left: calc(1rem + 24px) !important;
  border: 0 solid transparent !important;
}

/deep/.vs-input--placeholder {
  padding-left: calc(1rem + 24px) !important;
}

/deep/ .vs-con-input-label {
  width: 210px !important;
}

/deep/.vs-input--icon {
  top: auto;
  left: 0.5rem;
  @apply text-secondary;
}
</style>
